import { render, staticRenderFns } from "./ModalInsufficientCreditBuatKonten.vue?vue&type=template&id=17d818b0&"
import script from "./ModalInsufficientCreditBuatKonten.vue?vue&type=script&lang=js&"
export * from "./ModalInsufficientCreditBuatKonten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports